module.exports = __webpack_public_path__ + "media/images/icon__dropdown--arrow@2x-5d09c3ac15bdcf39a60c1a978774b84d.png";